$(window).on("scroll", function(){
  if ($(this).scrollTop() > 25) {
    $('.fixedelement').removeAttr("style")
  }else{
    $('.fixedelement').css({'display': 'none'});
  }
});